import {
  CHOOSE_CLIPART,
  DELETE_IMAGE,
  UPDATE_IMAGE_SIZE,
  RESIZE_IMAGE,
} from "../../actions";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {
    case CHOOSE_CLIPART:
      let photoStyle = false;
      let designImageCount = 0;

      // Print options only available for full color / photo styles
      if ('print_options' in state){
        photoStyle = true;

        //Get number of images for all layers
        designImageCount = state.layer_set.reduce((accumulator, current) => accumulator + current.image_elements.length, 0);
      }

      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {

            let layerLimit

            if (typeof action.payload.limits !== 'undefined'){
              layerLimit = action.payload.limits.limit
              if (!layerLimit){
                layerLimit = 3
              }
            }
            else {
              layerLimit = 1;
            }

            const selectedClipartIndex = layer.image_elements.findIndex(e => e.is_selected === true)
            if (selectedClipartIndex < 0) {

              // Limit clipart added based on product type limits across all layers for photo / full color styles
              if (photoStyle && designImageCount >= layerLimit * 2){
                return layer
              }
              // Limit clipart added based on product type limits
              else if (layer.image_elements.length >= layerLimit){
                return layer
              }
              // Calculate initial left position when adding a new clipart element to set it to center X of canvas
              let imageHeightCenter, imageWidthCenter, size, namedSize
              if (typeof action.payload.clipart !== 'undefined'){
                namedSize = action.payload.defaultImageSize;
                size = action.payload.clipart['size_' + namedSize];

                // No good way of finding width and height of the clipart so we'll use the size
                imageWidthCenter = size / 2;
                imageHeightCenter = size / 2;
              }
              else {
                // set padded height and width to keep imgaes from touching the borders
                let padding = .125;
                let layerPaddedHeight = layer.height - padding;
                let layerPaddedWidth = layer.width - padding;

                let artHeight = action.payload.userart.height / 72;
                let artWidth = action.payload.userart.width / 72;

                // scale art to the size of the canvas
                let heightRatio = layerPaddedHeight / artHeight;
                let widthRatio = layerPaddedWidth / artWidth;

                // use whichever ratio is greater
                let ratio = heightRatio < widthRatio ? heightRatio : widthRatio;

                // limit art size to prevent clipping
                if (ratio > 2){
                  ratio = 2;
                }

                // calculate center placement from ratio calculation
                imageHeightCenter = ((artHeight * ratio) / 2);
                imageWidthCenter = ((artWidth * ratio) / 2);

                size = 1;
                size = size * ratio;
              }

              let imageNumber = 0;
              let imagePosition = 0;

              // sort image elements by id
              layer.image_elements.sort((a,b) => a.id - b.id);

              // look for an empty id value in the sequential id order
              layer.image_elements.some(element => {
                if (element.id - imageNumber > 0){
                  return true;
                }
                imageNumber++;
              });

              // select placement position of image element based on image number
              if (imageNumber > 0) {
                imagePosition = imageNumber % 2 == 1 ? Math.ceil(imageNumber / 2) * -1 : Math.ceil(imageNumber / 2);
              }

              layer.image_elements.push({
                  id: imageNumber,
                  left_position: (layer.width / 2) - imageWidthCenter + (imagePosition * (layer.width * .12)), // offset placement of image based on number of images already included
                  top_position: (layer.height / 2) - imageHeightCenter,
                  rotation: 0,
                  size: size,
                  clipart: action.payload.clipart,
                  userart: action.payload.userart,
                  type: action.payload.type,
              })
            } else {
              //update selected clipart
              let selectedClipart = layer.image_elements[selectedClipartIndex]
              layer.image_elements[selectedClipartIndex] = {
                id: selectedClipart.id,
                left_position: selectedClipart.left_position,
                top_position: selectedClipart.top_position,
                size: layer.image_elements[selectedClipartIndex].size,
                rotation: 0,
                clipart: action.payload.clipart,
                userart: action.payload.userart,
                type: action.payload.type,
              }
            }
          }
          return layer;
        }),
      };

    case DELETE_IMAGE:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };
          if (layer.layer_id === action.payload.layerId) {
            layer.image_elements = layer.image_elements.filter(
              (imageField) => imageField.id !== action.payload.id,
            );
          }
          return layer;
        }),
      };

    case UPDATE_IMAGE_SIZE:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          const layer = { ...old_layer };

          if (layer.layer_id === action.payload.layerId) {
            layer.image_elements = layer.image_elements.map(
              (element, index) => {
                if (index === action.payload.index) {
                  return {
                    ...element,
                    size: action.payload.size,
                  };
                } else {
                  return element;
                }
              },
            );
          }
          return layer;
        }),
      };

    case RESIZE_IMAGE:
      return {
        ...state,
        layer_set: state.layer_set.map(old_layer => {
          const layer = {...old_layer}

          if (layer.layer_id === action.payload.layerId) {

            layer.image_elements[action.payload.index].width = action.payload.width;
            layer.image_elements[action.payload.index].height = action.payload.height;
            // layer.image_elements = layer.image_elements.map((element, index) => {
            //   return {
            //     ...element,
            //     width: action.payload.width,
            //     height: action.payload.height
            //   }
            // })
          }
          return layer;
        }),
      };

    default:
      return state;
  }
}
